import { render, staticRenderFns } from "./templateTargetFolderDialog.vue?vue&type=template&id=28f96ce8"
import script from "./templateTargetFolderDialog.vue?vue&type=script&lang=js"
export * from "./templateTargetFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports